window.addEventListener('DOMContentLoaded', (event) => {
    let heroHeight = $('.header-blog-search').height() + $('.header').height();
    window.onscroll = function () {
        let currentScrollPos = window.pageYOffset;
        if (currentScrollPos > heroHeight) {
            $('#blogNav').addClass('header-blog-fixed-top');
        } else {
            $('#blogNav').removeClass('header-blog-fixed-top');
        }
    };
});

window.addEventListener('DOMContentLoaded', (event) => {
    var activePageNumber;
    var pageNumber = {
        workplaces: 1,
        schools: 1,
        community: 1,
        personal: 1,
        companyNews: 1,
        latest: 1
    };
    function currentPageNumber(pageTab) {
        Object.keys(pageNumber).forEach(function (page) {
            if (page === pageTab) {
                activePageNumber = ++pageNumber[page];
            }
        });
    }

    function load_posts(currentTab, categoryId, pageNumber, postItems) {
        var currentTab = currentTab;
        var categoryId = categoryId;

        let str = '&pageNumber=' + pageNumber + '&ppp=' + postItems + '&category=' + categoryId + '&action=more_post_ajax';

        $.ajax({
            type: 'POST',
            dataType: 'html',
            url: $('#ajax_url').val(),
            data: str,
            success: function (data) {
                let $data = $(data);
                if ($data.length) {
                    $('#' + currentTab).find('.row').append($data);
                    $('#morePosts').attr('disabled', false);
                } else {
                    $('#morePosts').attr('disabled', true);
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(jqXHR + " :: " + textStatus + " :: " + errorThrown);
            }

        });
        return false;
    }

    $("#morePosts").on('click', function (e) {
        e.preventDefault();
        let currentTab = $('.tab-content').find('.active').attr('id');
        let currentCatId = $('.tab-content').find('.active').data('catid');
        $(this).attr('disabled', true);
        currentPageNumber(currentTab);
        load_posts(currentTab, currentCatId, activePageNumber, 18);
    });
});
